import { IconPropsType } from '../types'

const PendingTopUp = ({ width = 106, height = 106 }: IconPropsType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 106 107'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='53' cy='53.5' r='53' fill='#EAB308' fillOpacity='0.1' />
      <circle cx='53' cy='53.5' r='34.7812' fill='#EAB308' />
      <g clipPath='url(#clip0_14155_26902)'>
        <path
          d='M61.2812 67.3014L61.2674 59.0202L55.7604 53.4993L61.2674 47.9647L61.2812 39.6973H44.7188V47.9785L50.2396 53.4993L44.7188 59.0064V67.3014H61.2812ZM47.4792 47.2884V42.4577H58.5208V47.2884L53 52.8092L47.4792 47.2884Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_14155_26902'>
          <rect
            width='33.125'
            height='33.125'
            fill='white'
            transform='translate(36.4375 36.9375)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PendingTopUp
